import { accessToken } from '@/shared/helpers/CSRF'
import { loadStripe } from '@stripe/stripe-js'
import axios from '../lib/httpClient'
import createStripeAutoInit from './shared/stripe-auto-init'

async function initialize() {
  const stripe = await loadStripe(process.env.STRIPE_PUBLISHABLE_KEY)
  const fetchClientSecret = async () => {
    const response = await axios({
      method: 'post',
      url: '/gifts/checkout_session',
      headers: { 'X-CSRF-Token': accessToken },
    })

    return response.data.client_secret
  }

  const checkout = await stripe.createEmbeddedCheckoutPage({
    fetchClientSecret,
  })

  checkout.mount('#checkout')
}

createStripeAutoInit(initialize, { checkout: 'gift', listenToTurbo: true })
window.loadStripeCheckout = () => initialize()
